import { gql } from '@apollo/client';

export const REPORT_FILTERS = gql`
  query NoUserLogReportFilters {
    buyers {
      id
      fullDisplayName
    }
    locations(scopes: ["order_by_state_city"]) {
      id
      street
      city
      state
    }
    paddleServices {
      id
      name
    }
    sellers {
      id
      name
      fullDisplayName
    }
    sales {
      id
      name
    }
  }
`;

export const SEND_SALES_REPORT = gql`
  mutation SendSalesReport(
    $saleId: ID!
    $sellerId: ID
    $includeBOS: Boolean
  ) {
    sendSalesReport(
      saleId: $saleId
      sellerId: $sellerId
      includeBos: $includeBOS
    ) {
      sentCount
    }
  }
`;

export const SEND_BUYER_SUMMARY_REPORT = gql`
  mutation SendBuyerSummaryReport(
    $saleId: ID!
    $buyerId: ID
    $includeBOS: Boolean
  ) {
    sendBuyerSummaryReport(
      saleId: $saleId
      buyerId: $buyerId
      includeBos: $includeBOS
    ) {
      sentCount
    }
  }
`;

export const SEND_SELLER_DETAIL_REPORT = gql`
  mutation SendSellerDetailReport(
    $sellerId: ID!
    $saleId: ID
    $month: ISO8601Date
  ) {
    sendSellerDetailReport(
      sellerId: $sellerId
      saleId: $saleId
      month: $month
    ) {
      sentCount
    }
  }
`;
